import { render, staticRenderFns } from "./myCom.vue?vue&type=template&id=1b1739ba&scoped=true"
import script from "./myCom.vue?vue&type=script&lang=js"
export * from "./myCom.vue?vue&type=script&lang=js"
import style0 from "./myCom.vue?vue&type=style&index=0&id=1b1739ba&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1739ba",
  null
  
)

export default component.exports